import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAtX_B4V4HHkxgVTV_e9ULwsk1viEgw1fk",
  authDomain: "hisably-app.firebaseapp.com",
  projectId: "hisably-app",
  storageBucket: "hisably-app.firebasestorage.app",
  messagingSenderId: "888061009435",
  appId: "1:888061009435:web:2bb081919e70587220a2be",
  measurementId: "G-YPYNH7GK2R"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);